import { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Nav from "./Nav.js";
import InstallPrompt from "./InstallPrompt.js";
import CheckinBanner from "./CheckinBanner.js";
import { useAuth } from "../auth/AuthContext.js";
import { useOfflineSync } from "../lib/useOfflineSync.js";
import styles from "./Layout.module.css";

export default function Layout() {
  const { t } = useTranslation();
  const { authError } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  useOfflineSync();

  return (
    <div className={styles.root}>
      <Nav />
      {authError && !dismissed && (
        <div className={styles.authErrorBanner} role="alert">
          <span>{authError}</span>
          <button
            className={styles.authErrorDismiss}
            onClick={() => setDismissed(true)}
            aria-label="Lukk"
          >
            ✕
          </button>
        </div>
      )}
      <CheckinBanner />
      <main
        className={
          authError && !dismissed
            ? `${styles.main} ${styles.mainWithBanner}`
            : styles.main
        }
      >
        <Outlet />
      </main>
      <footer className={styles.footer}>
        <span className={styles.footerBrand}>Lakseborsen.no</span>
        <Link to="/kontakt" className={styles.footerLink}>
          {t("nav.contact")}
        </Link>
        {/* Static documents served by Caddy, so plain anchors (full page load) */}
        <a href="/privacy" className={styles.footerLink}>
          {t("nav.privacy")}
        </a>
        <a href="/subprocessors" className={styles.footerLink}>
          Databehandlere
        </a>
        <a href="/security" className={styles.footerLink}>
          Sikkerhet
        </a>
        <Link to="/elveeierlag" className={styles.footerLink}>
          {t("nav.riverOwnersAssoc")}
        </Link>
        <Link to="/selg-fiskekort" className={styles.footerLink}>
          {t("nav.sellFiskekort")}
        </Link>
      </footer>
      <InstallPrompt />
    </div>
  );
}
